(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(event){
    if(window.location.href.includes('?brand-list=')){
      const url = new URL(window.location.href);
      const brandListValue = url.searchParams.get('brand-list');
      const anchor = document.querySelector(`[href="#brand-list-${brandListValue}"]`);
      if(anchor) anchor.dispatchEvent(new Event('click'));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const content = document.querySelector("#description-content");
  const toggleButton = document.querySelector("#toggle-button");

  let originalScrollPosition = 0;

  if (content && toggleButton) {
    toggleButton.addEventListener("click", function () {
      const isExpanded = content.classList.contains("expanded");

      if (!isExpanded) {
        // Save the current scroll position before expanding
        originalScrollPosition = window.scrollY;
      }

      content.classList.toggle("truncate", isExpanded);
      content.classList.toggle("expanded", !isExpanded);
      toggleButton.textContent = isExpanded ? "Read More" : "Read Less";

      if (isExpanded) {
        // Scroll back to the original position after collapsing
        window.scrollTo({
          top: originalScrollPosition,
          behavior: "smooth"
        });
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
